import { ColocaBadge } from "@/shared/components/data-display/ColocaBadge";
import useTranslations from "@/shared/lang/useTranslations";

import { normalizeStatus, type CardStatus } from "../utils/cardHelpers";

type BadgeVariant = "success" | "warning" | "destructive" | "secondary" | "default";

const STATUS_VARIANT: Record<CardStatus, { variant: BadgeVariant; tKey: string }> = {
  ACTIVE: { variant: "success", tKey: "cards_status_active" },
  FROZEN: { variant: "secondary", tKey: "cards_status_frozen" },
  DISABLED: { variant: "destructive", tKey: "cards_status_disabled" },
  DELETED: { variant: "destructive", tKey: "cards_status_deleted" },
  PENDING_REVIEW: { variant: "warning", tKey: "cards_status_pending_review" },
};

type CardStatusBadgeProps = {
  /** Raw status string from the API (any casing); normalized internally. */
  status: string | undefined | null;
};

/**
 * Renders a card's status (Active / Frozen / Disabled / …) as a semantic badge. Shared by the cards list
 * (tile + row) and the pocket detail card list.
 */
export const CardStatusBadge = ({ status }: CardStatusBadgeProps) => {
  const { t } = useTranslations("cards");
  const meta = STATUS_VARIANT[normalizeStatus(status)];
  return <ColocaBadge variant={meta.variant}>{t(meta.tKey as never)}</ColocaBadge>;
};
